<template>
    <div class="login apppadding">
        <div class="logincontainer" style="height:auto;">
            <div>

                <div>
                    当前应用需要登录方可使用.
                </div>
            </div>
        </div>

        <div class="page-container-padding" style="height:auto;">
            <Button type="warning" :loading="loading" loading-text="授权登录中" size="large" round @click="login"> 授权并登录 </Button>
        </div>
    </div>
</template>

<script>
    import {getWechatCode} from '@/libs/wechat.js'
    import {wxLoginWap, userinfolist, info,wxLoginWap2} from '@/libs/api.js'
    import { getLastRouter, goBack, setStorage, islogin, userinfo,getStorage} from '@/libs/utils'
    import { Button,Toast } from 'vant'
    export default {
        name: 'matchdetail',
        components: {
            Button
        },
        data() {
            return {
                logo: '',
                loading: false
            }
        },
        methods: {
            login:function(){
                getWechatCode();
            }
        },
        mounted(options) {
            this.$nextTick(() => {

                if(!islogin()){
                   if(!!this.$route.query.code){

                       wxLoginWap({code:this.$route.query.code}).then((res)=>{
                           if(res.status!=200){
                               this.$router.push({
                                   query:{}
                               })
                           }else{
                               //跳转到 登录前的页面
                               Toast.clear();
                               let to = getLastRouter()
                               let urid = res.data.urid
                               let token = res.data.token
                               userinfolist({urid:res.data.urid,token:res.data.token}).then((res)=>{
                                   if(res.status == 200){
                                       let rawData = res.data
                                       rawData.urid = urid
                                       rawData.token = token
                                       rawData.logintime = new Date().getTime()
                                       setStorage('userInfo',rawData, true)
                                       this.$router.replace({name:to.name,params:to.params})
                                   }
                               })

                           }

                       })
                    }else{
                       getWechatCode();

                   }
                }else{
                    var currentUrl = window.location.pathname
                    goBack(currentUrl)
                }


            })

        }
    }
</script>

<style scoped lang="less">
    .login{
        .logincontainer{
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            padding: 100px 0;
            box-sizing: border-box;
        }

        .logincontainer div{
            display:flex;
            flex-direction:column;
            align-items:center;
        }
        /*.container view>view:nth-child(2)*/
        /*{*/
        /*margin:20rpx auto;*/
        /*font-size:40rpx;*/
        /*}*/
        .logincontainer div img:nth-child(1)
        {
            width:120px;
            /*height:343rpx;*/
            /*border-radius:50%;*/
        }

        .logincontainer div:nth-child(1) img:nth-child(2)
        {
            width:320px;
            height:91px;
        }
        .logincontainer div div:last-child{
            height:100px;
            width:350px;
            font-size:14px;
            background-image:url('https://moveclub-file.oss-cn-hangzhou.aliyuncs.com/icon/logintips.png');
            background-size:100% 100%;
            padding:12px;
            padding-top:22.5px;
            box-sizing:border-box;
            display:flex;
            align-items:center;
            justify-content:center;
        }
        .footer{
            box-shadow:none;
        }
    }

</style>

